const GROUP_METRICS = [
  {
    group: 93538,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93541,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93543,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93545,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93547,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93546,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93548,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 87436,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 87434,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 87442,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 593,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 87384,
    data: [
      {
        before: '2023-06-18',
        after: '2023-06-12',
        'branch.computed.cycle_time:avg': 1367,
        'branch.time_to_pr:avg': 858,
        'branch.time_to_review:avg': 444,
        'branch.review_time:avg': 65,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 64,
        'pr.review_depth': 0.83,
        'commit.activity.new_work.count': 2231,
        'commit.total_changes': 2481,
        'commit.activity.refactor.count': 24,
        'commit.activity.rework.count': 226,
        'pr.merged.without.review.count': 58,
        'commit.total.count': 445,
        'pr.new': 105,
        'pr.merged': 96,
        'pr.reviews': 121,
        'releases.count': 0,
        'commit.activity_days': 50,
        'branch.state.computed.done': 96,
        'branch.state.active': null,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null,
        'pm.mttr': null,
        'pm.cfr.issues.done': 0
      }
    ]
  },
  {
    group: 93544,
    data: [
      {
        before: '2023-06-11',
        after: '2023-06-05',
        'pr.merged': 20,
        'releases.count': 10,
        'pr.merged.size:avg': 150,
        'branch.time_to_pr:avg': 163,
        'branch.time_to_review:avg': 848,
        'branch.review_time:avg': 904,
        'branch.time_to_prod:avg': 997,
        'branch.computed.cycle_time:avg': 2111
      }
    ]
  }
];

const SELECTED_GROUP = [
  {
    id: 93538,
    organization_id: 93672499,
    name: 'General LinearB',
    initials: 'GEN',
    color: '#FF9800',
    extra: {
      setting_key: 'LinearB1_93713',
      provider_node_id: 'T_kwDOA7Lcj84AZIK-',
      provider_team_name: 'General LinearB'
    },
    created_at: '2023-02-23T12:25:18.011Z',
    updated_at: '2023-04-04T07:09:00.260Z',
    deleted_at: null,
    established_at: '2023-02-23T12:25:18.000Z',
    project_id: 1765700243,
    parent_id: null,
    provider_id: '6587070',
    type: 'group',
    contributors: [
      {
        id: 24173714,
        name: 'Mark Bulgakov',
        parent_id: null,
        provider_id: '109464254',
        roles: [
          {
            roles: ['contributor'],
            start: '2023-02-23T12:25:18',
            end: null
          }
        ]
      },
      {
        id: 1122209828,
        name: 'Anonymous-46413697',
        parent_id: null,
        provider_id: '46413697',
        roles: [
          {
            roles: ['contributor'],
            start: '2023-02-23T12:25:18',
            end: null
          }
        ]
      }
    ],
    contributor_ids: [24173714, 1122209828],
    isSynced: false,
    syncedProviderName: 'General LinearB',
    isParent: true,
    children: [
      {
        id: 93541,
        organization_id: 93672499,
        name: 'Israel LinearB',
        initials: 'ISR',
        color: '#8795FF',
        extra: {
          setting_key: 'LinearB1_93713',
          provider_node_id: 'T_kwDOA7Lcj84AZIK5',
          provider_team_name: 'Israel LinearB'
        },
        created_at: '2023-02-23T12:25:18.624Z',
        updated_at: '2023-04-04T07:09:00.260Z',
        deleted_at: null,
        established_at: '2023-02-23T12:25:18.000Z',
        project_id: 1341072526,
        parent_id: 93538,
        provider_id: '6587065',
        type: 'synced',
        contributors: [
          {
            id: 24173714,
            name: 'Mark Bulgakov',
            parent_id: null,
            provider_id: '109464254',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          },
          {
            id: 1122209828,
            name: 'Anonymous-46413697',
            parent_id: null,
            provider_id: '46413697',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          },
          {
            id: 1690639405,
            name: 'Dave Eloper',
            parent_id: null,
            provider_id: '45555826',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          }
        ],
        contributor_ids: [24173714, 1122209828, 1690639405],
        isSynced: true,
        syncedProviderName: 'Israel LinearB',
        isParent: true,
        children: [
          {
            id: 93543,
            organization_id: 93672499,
            name: 'Israel R&D LinearB',
            initials: 'IS1',
            color: '#0276AB',
            extra: {
              setting_key: 'LinearB1_93713',
              provider_node_id: 'T_kwDOA7Lcj84AZIM8',
              provider_team_name: 'Israel R&D LinearB'
            },
            created_at: '2023-02-23T12:25:19.105Z',
            updated_at: '2023-04-04T07:09:00.260Z',
            deleted_at: null,
            established_at: '2023-02-23T12:25:19.000Z',
            project_id: 458770032,
            parent_id: 93541,
            provider_id: '6587196',
            type: 'synced',
            contributors: [
              {
                id: 24173714,
                name: 'Mark Bulgakov',
                parent_id: null,
                provider_id: '109464254',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              },
              {
                id: 1122209828,
                name: 'Anonymous-46413697',
                parent_id: null,
                provider_id: '46413697',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              },
              {
                id: 1690639405,
                name: 'Dave Eloper',
                parent_id: null,
                provider_id: '45555826',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              }
            ],
            contributor_ids: [24173714, 1122209828, 1690639405],
            isSynced: true,
            syncedProviderName: 'Israel R&D LinearB',
            isParent: true,
            children: [
              {
                id: 93545,
                organization_id: 93672499,
                name: 'Israel R&D Developers LinearB',
                initials: 'IS2',
                color: '#008114',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AZINB',
                  provider_team_name: 'Israel R&D Developers LinearB'
                },
                created_at: '2023-02-23T12:25:19.594Z',
                updated_at: '2023-04-04T07:09:00.260Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 2086364839,
                parent_id: 93543,
                provider_id: '6587201',
                type: 'synced',
                contributors: [
                  {
                    id: 24173714,
                    name: 'Mark Bulgakov',
                    parent_id: null,
                    provider_id: '109464254',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 54506418,
                    name: 'oren yosef',
                    parent_id: null,
                    provider_id: '104711789',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 241492707,
                    name: 'Mark Bulgakov',
                    parent_id: null,
                    provider_id: '21018826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [24173714, 54506418, 241492707, 1690639405],
                isSynced: true,
                syncedProviderName: 'Israel R&D Developers LinearB',
                isParent: true,
                children: [
                  {
                    id: 93547,
                    organization_id: 93672499,
                    name: 'Besties',
                    initials: 'BES',
                    color: '#B30000',
                    extra: {
                      setting_key: 'LinearB1_93713',
                      provider_node_id: 'T_kwDOA7Lcj84AamHq',
                      provider_team_name: 'Besties'
                    },
                    created_at: '2023-02-23T12:25:20.146Z',
                    updated_at: '2023-04-04T07:09:00.260Z',
                    deleted_at: null,
                    established_at: '2023-02-23T12:25:20.000Z',
                    project_id: 1553234054,
                    parent_id: 93545,
                    provider_id: '6971882',
                    type: 'synced',
                    contributors: [
                      {
                        id: 1690639405,
                        name: 'Dave Eloper',
                        parent_id: null,
                        provider_id: '45555826',
                        roles: [
                          {
                            roles: ['contributor'],
                            start: '2023-02-23T12:25:20',
                            end: null
                          }
                        ]
                      }
                    ],
                    contributor_ids: [1690639405],
                    isSynced: true,
                    syncedProviderName: 'Besties',
                    isParent: false,
                    children: []
                  }
                ]
              },
              {
                id: 93546,
                organization_id: 93672499,
                name: 'Israel R&D QA LinearB',
                initials: 'IS3',
                color: '#03A9F4',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AZINC',
                  provider_team_name: 'Israel R&D QA LinearB'
                },
                created_at: '2023-02-23T12:25:19.874Z',
                updated_at: '2023-04-04T07:09:00.260Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 1538222106,
                parent_id: 93543,
                provider_id: '6587202',
                type: 'synced',
                contributors: [
                  {
                    id: 1122209828,
                    name: 'Anonymous-46413697',
                    parent_id: null,
                    provider_id: '46413697',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [1122209828, 1690639405],
                isSynced: true,
                syncedProviderName: 'Israel R&D QA LinearB',
                isParent: true,
                children: [
                  {
                    id: 93548,
                    organization_id: 93672499,
                    name: 'QA team 1',
                    initials: 'QA',
                    color: '#8795FF',
                    extra: {
                      setting_key: 'LinearB1_93713',
                      provider_node_id: 'T_kwDOA7Lcj84Aaf5z',
                      provider_team_name: 'QA team 1'
                    },
                    created_at: '2023-02-23T12:25:20.394Z',
                    updated_at: '2023-04-04T07:09:00.260Z',
                    deleted_at: null,
                    established_at: '2023-02-23T12:25:20.000Z',
                    project_id: 2139883700,
                    parent_id: 93546,
                    provider_id: '6946419',
                    type: 'synced',
                    contributors: [
                      {
                        id: 1690639405,
                        name: 'Dave Eloper',
                        parent_id: null,
                        provider_id: '45555826',
                        roles: [
                          {
                            roles: ['contributor'],
                            start: '2023-02-23T12:25:20',
                            end: null
                          }
                        ]
                      }
                    ],
                    contributor_ids: [1690639405],
                    isSynced: true,
                    syncedProviderName: 'QA team 1',
                    isParent: false,
                    children: []
                  }
                ]
              },
              {
                id: 93544,
                organization_id: 93672499,
                name: 'DEVOPS Israel',
                initials: 'DEV',
                color: '#4FC3F7',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AaXHY',
                  provider_team_name: 'DEVOPS Israel'
                },
                created_at: '2023-02-23T12:25:19.346Z',
                updated_at: '2023-04-23T11:44:03.245Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 633689852,
                parent_id: 93543,
                provider_id: '6910424',
                type: 'synced',
                contributors: [
                  {
                    id: 312375315,
                    name: 'Stas Onichak ',
                    parent_id: null,
                    provider_id: '84438797',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [312375315, 1690639405],
                isSynced: true,
                syncedProviderName: 'DEVOPS Israel',
                isParent: false,
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
];

const SELECTED_GROUP_SYNCED = [
  {
    id: 93538,
    organization_id: 93672499,
    name: 'General LinearB',
    initials: 'GEN',
    color: '#FF9800',
    extra: {
      setting_key: 'LinearB1_93713',
      provider_node_id: 'T_kwDOA7Lcj84AZIK-',
      provider_team_name: 'General LinearB'
    },
    created_at: '2023-02-23T12:25:18.011Z',
    updated_at: '2023-04-04T07:09:00.260Z',
    deleted_at: null,
    established_at: '2023-02-23T12:25:18.000Z',
    project_id: 1765700243,
    parent_id: null,
    provider_id: '6587070',
    type: 'synced',
    contributors: [
      {
        id: 24173714,
        name: 'Mark Bulgakov',
        parent_id: null,
        provider_id: '109464254',
        roles: [
          {
            roles: ['contributor'],
            start: '2023-02-23T12:25:18',
            end: null
          }
        ]
      },
      {
        id: 1122209828,
        name: 'Anonymous-46413697',
        parent_id: null,
        provider_id: '46413697',
        roles: [
          {
            roles: ['contributor'],
            start: '2023-02-23T12:25:18',
            end: null
          }
        ]
      }
    ],
    contributor_ids: [24173714, 1122209828],
    isSynced: true,
    syncedProviderName: 'General LinearB',
    isParent: true,
    children: [
      {
        id: 93541,
        organization_id: 93672499,
        name: 'Israel LinearB',
        initials: 'ISR',
        color: '#8795FF',
        extra: {
          setting_key: 'LinearB1_93713',
          provider_node_id: 'T_kwDOA7Lcj84AZIK5',
          provider_team_name: 'Israel LinearB'
        },
        created_at: '2023-02-23T12:25:18.624Z',
        updated_at: '2023-04-04T07:09:00.260Z',
        deleted_at: null,
        established_at: '2023-02-23T12:25:18.000Z',
        project_id: 1341072526,
        parent_id: 93538,
        provider_id: '6587065',
        type: 'synced',
        contributors: [
          {
            id: 24173714,
            name: 'Mark Bulgakov',
            parent_id: null,
            provider_id: '109464254',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          },
          {
            id: 1122209828,
            name: 'Anonymous-46413697',
            parent_id: null,
            provider_id: '46413697',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          },
          {
            id: 1690639405,
            name: 'Dave Eloper',
            parent_id: null,
            provider_id: '45555826',
            roles: [
              {
                roles: ['contributor'],
                start: '2023-02-23T12:25:18',
                end: null
              }
            ]
          }
        ],
        contributor_ids: [24173714, 1122209828, 1690639405],
        isSynced: true,
        syncedProviderName: 'Israel LinearB',
        isParent: true,
        children: [
          {
            id: 93543,
            organization_id: 93672499,
            name: 'Israel R&D LinearB',
            initials: 'IS1',
            color: '#0276AB',
            extra: {
              setting_key: 'LinearB1_93713',
              provider_node_id: 'T_kwDOA7Lcj84AZIM8',
              provider_team_name: 'Israel R&D LinearB'
            },
            created_at: '2023-02-23T12:25:19.105Z',
            updated_at: '2023-04-04T07:09:00.260Z',
            deleted_at: null,
            established_at: '2023-02-23T12:25:19.000Z',
            project_id: 458770032,
            parent_id: 93541,
            provider_id: '6587196',
            type: 'synced',
            contributors: [
              {
                id: 24173714,
                name: 'Mark Bulgakov',
                parent_id: null,
                provider_id: '109464254',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              },
              {
                id: 1122209828,
                name: 'Anonymous-46413697',
                parent_id: null,
                provider_id: '46413697',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              },
              {
                id: 1690639405,
                name: 'Dave Eloper',
                parent_id: null,
                provider_id: '45555826',
                roles: [
                  {
                    roles: ['contributor'],
                    start: '2023-02-23T12:25:19',
                    end: null
                  }
                ]
              }
            ],
            contributor_ids: [24173714, 1122209828, 1690639405],
            isSynced: true,
            syncedProviderName: 'Israel R&D LinearB',
            isParent: true,
            children: [
              {
                id: 93545,
                organization_id: 93672499,
                name: 'Israel R&D Developers LinearB',
                initials: 'IS2',
                color: '#008114',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AZINB',
                  provider_team_name: 'Israel R&D Developers LinearB'
                },
                created_at: '2023-02-23T12:25:19.594Z',
                updated_at: '2023-04-04T07:09:00.260Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 2086364839,
                parent_id: 93543,
                provider_id: '6587201',
                type: 'synced',
                contributors: [
                  {
                    id: 24173714,
                    name: 'Mark Bulgakov',
                    parent_id: null,
                    provider_id: '109464254',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 54506418,
                    name: 'oren yosef',
                    parent_id: null,
                    provider_id: '104711789',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 241492707,
                    name: 'Mark Bulgakov',
                    parent_id: null,
                    provider_id: '21018826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [24173714, 54506418, 241492707, 1690639405],
                isSynced: true,
                syncedProviderName: 'Israel R&D Developers LinearB',
                isParent: true,
                children: [
                  {
                    id: 93547,
                    organization_id: 93672499,
                    name: 'Besties',
                    initials: 'BES',
                    color: '#B30000',
                    extra: {
                      setting_key: 'LinearB1_93713',
                      provider_node_id: 'T_kwDOA7Lcj84AamHq',
                      provider_team_name: 'Besties'
                    },
                    created_at: '2023-02-23T12:25:20.146Z',
                    updated_at: '2023-04-04T07:09:00.260Z',
                    deleted_at: null,
                    established_at: '2023-02-23T12:25:20.000Z',
                    project_id: 1553234054,
                    parent_id: 93545,
                    provider_id: '6971882',
                    type: 'synced',
                    contributors: [
                      {
                        id: 1690639405,
                        name: 'Dave Eloper',
                        parent_id: null,
                        provider_id: '45555826',
                        roles: [
                          {
                            roles: ['contributor'],
                            start: '2023-02-23T12:25:20',
                            end: null
                          }
                        ]
                      }
                    ],
                    contributor_ids: [1690639405],
                    isSynced: true,
                    syncedProviderName: 'Besties',
                    isParent: false,
                    children: []
                  }
                ]
              },
              {
                id: 93546,
                organization_id: 93672499,
                name: 'Israel R&D QA LinearB',
                initials: 'IS3',
                color: '#03A9F4',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AZINC',
                  provider_team_name: 'Israel R&D QA LinearB'
                },
                created_at: '2023-02-23T12:25:19.874Z',
                updated_at: '2023-04-04T07:09:00.260Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 1538222106,
                parent_id: 93543,
                provider_id: '6587202',
                type: 'synced',
                contributors: [
                  {
                    id: 1122209828,
                    name: 'Anonymous-46413697',
                    parent_id: null,
                    provider_id: '46413697',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [1122209828, 1690639405],
                isSynced: true,
                syncedProviderName: 'Israel R&D QA LinearB',
                isParent: true,
                children: [
                  {
                    id: 93548,
                    organization_id: 93672499,
                    name: 'QA team 1',
                    initials: 'QA',
                    color: '#8795FF',
                    extra: {
                      setting_key: 'LinearB1_93713',
                      provider_node_id: 'T_kwDOA7Lcj84Aaf5z',
                      provider_team_name: 'QA team 1'
                    },
                    created_at: '2023-02-23T12:25:20.394Z',
                    updated_at: '2023-04-04T07:09:00.260Z',
                    deleted_at: null,
                    established_at: '2023-02-23T12:25:20.000Z',
                    project_id: 2139883700,
                    parent_id: 93546,
                    provider_id: '6946419',
                    type: 'synced',
                    contributors: [
                      {
                        id: 1690639405,
                        name: 'Dave Eloper',
                        parent_id: null,
                        provider_id: '45555826',
                        roles: [
                          {
                            roles: ['contributor'],
                            start: '2023-02-23T12:25:20',
                            end: null
                          }
                        ]
                      }
                    ],
                    contributor_ids: [1690639405],
                    isSynced: true,
                    syncedProviderName: 'QA team 1',
                    isParent: false,
                    children: []
                  }
                ]
              },
              {
                id: 93544,
                organization_id: 93672499,
                name: 'DEVOPS Israel',
                initials: 'DEV',
                color: '#4FC3F7',
                extra: {
                  setting_key: 'LinearB1_93713',
                  provider_node_id: 'T_kwDOA7Lcj84AaXHY',
                  provider_team_name: 'DEVOPS Israel'
                },
                created_at: '2023-02-23T12:25:19.346Z',
                updated_at: '2023-04-23T11:44:03.245Z',
                deleted_at: null,
                established_at: '2023-02-23T12:25:19.000Z',
                project_id: 633689852,
                parent_id: 93543,
                provider_id: '6910424',
                type: 'synced',
                contributors: [
                  {
                    id: 312375315,
                    name: 'Stas Onichak ',
                    parent_id: null,
                    provider_id: '84438797',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  },
                  {
                    id: 1690639405,
                    name: 'Dave Eloper',
                    parent_id: null,
                    provider_id: '45555826',
                    roles: [
                      {
                        roles: ['contributor'],
                        start: '2023-02-23T12:25:19',
                        end: null
                      }
                    ]
                  }
                ],
                contributor_ids: [312375315, 1690639405],
                isSynced: true,
                syncedProviderName: 'DEVOPS Israel',
                isParent: false,
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
];

const GROUP_METRICS_5_ITERATIONS = [
  {
    group: 87436,
    data: [
      {
        before: '2023-06-25',
        after: '2023-06-12',
        'branch.time_to_pr:avg': 636,
        'branch.time_to_review:avg': 817,
        'branch.review_time:avg': 2406,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 104,
        'pr.reviews': 159,
        'commit.activity_days': 52,
        'commit.activity.new_work.count': 1087,
        'commit.total_changes': 1299,
        'commit.activity.rework.count': 112,
        'commit.activity.refactor.count': 100,
        'pr.review_depth': 0.8,
        'releases.count': 0
      },
      {
        before: '2023-06-11',
        after: '2023-06-05',
        'branch.time_to_pr:avg': 187,
        'branch.time_to_review:avg': 98,
        'branch.review_time:avg': 269,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 285,
        'pr.reviews': 269,
        'commit.activity_days': 42,
        'commit.activity.new_work.count': 10974,
        'commit.total_changes': 12018,
        'commit.activity.rework.count': 280,
        'commit.activity.refactor.count': 764,
        'pr.review_depth': 0.75,
        'releases.count': 0
      },
      {
        before: '2023-06-04',
        after: '2023-05-29',
        'branch.time_to_pr:avg': 174,
        'branch.time_to_review:avg': 55,
        'branch.review_time:avg': 120,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 503,
        'pr.reviews': 257,
        'commit.activity_days': 56,
        'commit.activity.new_work.count': 4593,
        'commit.total_changes': 6290,
        'commit.activity.rework.count': 1156,
        'commit.activity.refactor.count': 541,
        'pr.review_depth': 0.73,
        'releases.count': 0
      },
      {
        before: '2023-05-28',
        after: '2023-05-22',
        'branch.time_to_pr:avg': 100,
        'branch.time_to_review:avg': 61,
        'branch.review_time:avg': 109,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 475,
        'pr.reviews': 151,
        'commit.activity_days': 46,
        'commit.activity.new_work.count': 9752,
        'commit.total_changes': 11826,
        'commit.activity.rework.count': 518,
        'commit.activity.refactor.count': 1556,
        'pr.review_depth': 0.79,
        'releases.count': 0
      },
      {
        before: '2023-05-21',
        after: '2023-05-15',
        'branch.time_to_pr:avg': 157,
        'branch.time_to_review:avg': 31,
        'branch.review_time:avg': 47,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 580,
        'pr.reviews': 213,
        'commit.activity_days': 48,
        'commit.activity.new_work.count': 6546,
        'commit.total_changes': 10025,
        'commit.activity.rework.count': 525,
        'commit.activity.refactor.count': 2954,
        'pr.review_depth': 0.62,
        'releases.count': 0
      }
    ]
  },
  {
    group: 93538,
    data: [
      {
        before: '2023-06-25',
        after: '2023-06-12',
        'branch.time_to_pr:avg': 636,
        'branch.time_to_review:avg': 817,
        'branch.review_time:avg': 2406,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 104,
        'pr.reviews': 159,
        'commit.activity_days': 52,
        'commit.activity.new_work.count': 1087,
        'commit.total_changes': 1299,
        'commit.activity.rework.count': 112,
        'commit.activity.refactor.count': 100,
        'pr.review_depth': 0.8,
        'releases.count': 0
      },
      {
        before: '2023-06-11',
        after: '2023-06-05',
        'branch.time_to_pr:avg': 187,
        'branch.time_to_review:avg': 98,
        'branch.review_time:avg': 269,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 285,
        'pr.reviews': 269,
        'commit.activity_days': 42,
        'commit.activity.new_work.count': 10974,
        'commit.total_changes': 12018,
        'commit.activity.rework.count': 280,
        'commit.activity.refactor.count': 764,
        'pr.review_depth': 0.75,
        'releases.count': 0
      },
      {
        before: '2023-06-04',
        after: '2023-05-29',
        'branch.time_to_pr:avg': 174,
        'branch.time_to_review:avg': 55,
        'branch.review_time:avg': 120,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 503,
        'pr.reviews': 257,
        'commit.activity_days': 56,
        'commit.activity.new_work.count': 4593,
        'commit.total_changes': 6290,
        'commit.activity.rework.count': 1156,
        'commit.activity.refactor.count': 541,
        'pr.review_depth': 0.73,
        'releases.count': 0
      },
      {
        before: '2023-05-28',
        after: '2023-05-22',
        'branch.time_to_pr:avg': 100,
        'branch.time_to_review:avg': 61,
        'branch.review_time:avg': 109,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 475,
        'pr.reviews': 151,
        'commit.activity_days': 46,
        'commit.activity.new_work.count': 9752,
        'commit.total_changes': 11826,
        'commit.activity.rework.count': 518,
        'commit.activity.refactor.count': 1556,
        'pr.review_depth': 0.79,
        'releases.count': 0
      },
      {
        before: '2023-05-21',
        after: '2023-05-15',
        'branch.time_to_pr:avg': 157,
        'branch.time_to_review:avg': 31,
        'branch.review_time:avg': 47,
        'branch.time_to_prod:avg': null,
        'branch.state.computed.done': 580,
        'pr.reviews': 213,
        'commit.activity_days': 48,
        'commit.activity.new_work.count': 6546,
        'commit.total_changes': 10025,
        'commit.activity.rework.count': 525,
        'commit.activity.refactor.count': 2954,
        'pr.review_depth': 0.62,
        'releases.count': 0
      }
    ]
  }
];

const WIDGETS_DATA = [
  {
    id: 1,
    name: 'Cycle Time',
    description: 'Time from first commit to release',
    category: 'Delivery',
    unitType: 'timespan',
    articleId: 'v9pckvmkbj',
    metrics: [
      {
        name: 'branch.computed.cycle_time'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 2,
    name: 'Coding Time',
    description: 'Time from first commit to pull request creation',
    category: 'Delivery',
    displayName: 'Coding time',
    unitType: 'timespan',
    articleId: 'v9pckvmkbj',
    metrics: [
      {
        name: 'branch.time_to_pr'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 3,
    name: 'Pickup Time',
    description: 'Time from pull request creation to review',
    category: 'Delivery',
    unitType: 'timespan',
    articleId: 'v9pckvmkbj',
    metrics: [
      {
        name: 'branch.time_to_review'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 4,
    name: 'Review Time',
    description: 'Time from review beginning to pull request merged',
    category: 'Delivery',
    articleId: 'v9pckvmkbj',
    metrics: [
      {
        name: 'branch.review_time'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 5,
    name: 'Deploy Time',
    description: 'Time from pull request merge to release',
    category: 'Delivery',
    unitType: 'timespan',
    articleId: 'v9pckvmkbj',
    metrics: [
      {
        name: 'branch.time_to_prod'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 6,
    name: 'PR Size',
    description: 'Size of pull request (total lines of code changed)',
    category: 'Quality',
    unitType: 'nonAvgCount',
    displayLabel: 'Code changes',
    unitDescription: 'Code changes per PR',
    articleId: 'x1620txj8m',
    metrics: [
      {
        name: 'pr.merged.size',
        avgBy: 'pr.merged'
      }
    ]
  },
  {
    id: 7,
    name: 'Review Depth',
    description: 'Avg. number of comments per review',
    category: 'Quality',
    unitType: 'nonAvgCount',
    displayLabel: 'Comments per review',
    unitDescription: 'Comments per review',
    articleId: 'sf643osbmq',
    metrics: [
      {
        name: 'pr.review_depth'
      }
    ],
    avgOnlyWhenDataAvailable: true
  },
  {
    id: 8,
    name: 'New code',
    description: 'Ratio of new code',
    category: 'Quality',
    unitType: 'percentage',
    displayLabel: 'Of code changes',
    unitDescription: 'New code',
    articleId: 'tpxx3m8cwb',
    metrics: [
      {
        name: 'commit.activity.new_work.count',
        percentOff: {
          id: 12,
          name: 'Code changes',
          description: 'Lines of code changed',
          category: 'Throughput',
          unitType: 'count',
          displayLabel: 'Changes',
          unitDescription: 'Code changes per',
          articleId: 'tpmxyz5ei7',
          metrics: [
            {
              name: 'commit.total_changes'
            }
          ]
        }
      }
    ]
  },
  {
    id: 9,
    name: 'Refactor',
    description: 'Ratio of legacy code changed (more than 21 days)',
    category: 'Quality',
    unitType: 'percentage',
    displayLabel: 'Of code changes',
    unitDescription: 'Refactor code',
    articleId: 'tpxx3m8cwb',
    metrics: [
      {
        name: 'commit.activity.refactor.count',
        percentOff: {
          id: 12,
          name: 'Code changes',
          description: 'Lines of code changed',
          category: 'Throughput',
          unitType: 'count',
          displayLabel: 'Changes',
          unitDescription: 'Code changes per',
          articleId: 'tpmxyz5ei7',
          metrics: [
            {
              name: 'commit.total_changes'
            }
          ]
        }
      }
    ]
  },
  {
    id: 10,
    name: 'Rework',
    description: 'Ratio of novice code changed (less than 21 days)',
    category: 'Quality',
    displayLabel: 'Of code changes',
    unitType: 'percentage',
    articleId: 'tpxx3m8cwb',
    metrics: [
      {
        name: 'commit.activity.rework.count',
        percentOff: {
          id: 12,
          name: 'Code changes',
          description: 'Lines of code changed',
          category: 'Throughput',
          unitType: 'count',
          displayLabel: 'Changes',
          unitDescription: 'Code changes per',
          articleId: 'tpmxyz5ei7',
          metrics: [
            {
              name: 'commit.total_changes'
            }
          ]
        }
      }
    ]
  },
  {
    id: 11,
    name: 'PRs merged w/o review',
    description: 'Number of pull requests merged without any review',
    category: 'Quality',
    unitType: 'count',
    displayLabel: 'PRs',
    unitDescription: 'PRs per',
    articleId: 's0jjewxoh9',
    metrics: [
      {
        name: 'pr.merged.without.review.count'
      }
    ]
  },
  {
    id: 12,
    name: 'Code changes',
    description: 'Lines of code changed',
    category: 'Throughput',
    unitType: 'count',
    displayLabel: 'Changes',
    unitDescription: 'Code changes per',
    articleId: 'tpmxyz5ei7',
    metrics: [
      {
        name: 'commit.total_changes'
      }
    ]
  },
  {
    id: 13,
    name: 'Commits',
    description: 'Number of commits',
    category: 'Throughput',
    unitType: 'count',
    unitDescription: 'Commits per',
    displayLabel: 'Commits',
    articleId: 'tpmxyz5ei7',
    metrics: [
      {
        name: 'commit.total.count'
      }
    ]
  },
  {
    id: 14,
    name: 'PRs opened',
    description: 'Number of pull requests opened',
    category: 'Throughput',
    unitType: 'count',
    displayLabel: 'PRs',
    unitDescription: 'PRs per',
    articleId: 'tpmxyz5ei7',
    metrics: [
      {
        name: 'pr.new'
      }
    ]
  },
  {
    id: 15,
    name: 'PRs merged',
    description: 'Number of pull requests merged',
    category: 'Throughput',
    unitType: 'count',
    displayLabel: 'PRs',
    unitDescription: 'PRs per',
    articleId: 'tpmxyz5ei7',
    metrics: [
      {
        name: 'pr.merged'
      }
    ]
  },
  {
    id: 16,
    name: 'Reviews',
    description: 'Number of pull requests reviews',
    category: 'Throughput',
    unitType: 'count',
    unitDescription: 'Reviews per',
    displayLabel: 'Reviews',
    articleId: 'tpmxyz5ei7',
    metrics: [
      {
        name: 'pr.reviews'
      }
    ]
  },
  {
    id: 18,
    name: 'Deploy frequency',
    description: 'Avg. of releases per day',
    category: 'Throughput',
    unitType: 'count',
    unitDescription: 'per',
    displayLabel: 'Deployments',
    articleId: 'gm1zmtps8p',
    metrics: [
      {
        name: 'releases.count'
      }
    ]
  },
  {
    id: 19,
    name: 'Active days',
    description:
      'Number of days with Git activity (commits, PRs, Reviews etc.)',
    category: 'Balance',
    unitType: 'count',
    displayLabel: 'Active days',
    metrics: [
      {
        name: 'commit.activity_days'
      }
    ]
  },
  {
    id: 20,
    name: 'Done Branches',
    description: 'Number of branches moved to state merged or released ',
    category: 'Throughput',
    unitType: 'count',
    displayLabel: 'Branches done',
    metrics: [
      {
        name: 'branch.state.computed.done'
      }
    ]
  },
  {
    id: 21,
    name: 'Active Branches',
    description: 'Number of branches in active state',
    category: 'Balance',
    unitType: 'count',
    displayLabel: 'Active branches',
    metrics: [
      {
        name: 'branch.state.active'
      }
    ]
  }
];

const METRICS_DATA_ONE_DAY_ROLL_UP = [
  {
    group: 87436,
    data: [
      {
        before: '2023-06-19',
        after: '2023-06-19',
        'branch.computed.cycle_time:avg': 43723,
        'branch.time_to_pr:avg': 81,
        'branch.time_to_review:avg': 8574,
        'branch.review_time:avg': 35068,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 7517,
        'pr.review_depth': 0.2,
        'commit.activity.new_work.count': 100,
        'commit.total_changes': 101,
        'commit.activity.refactor.count': 1,
        'commit.activity.rework.count': 0,
        'pr.merged.without.review.count': 0,
        'commit.total.count': 4,
        'pr.new': 2,
        'pr.merged': 3,
        'pr.reviews': 5,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 3,
        'branch.state.active': 1,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-20',
        after: '2023-06-20',
        'branch.computed.cycle_time:avg': 123,
        'branch.time_to_pr:avg': 122,
        'branch.time_to_review:avg': 1,
        'branch.review_time:avg': 0,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 2,
        'pr.review_depth': 0.67,
        'commit.activity.new_work.count': 108,
        'commit.total_changes': 111,
        'commit.activity.refactor.count': 3,
        'commit.activity.rework.count': 0,
        'pr.merged.without.review.count': 0,
        'commit.total.count': 12,
        'pr.new': 1,
        'pr.merged': 1,
        'pr.reviews': 3,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 1,
        'branch.state.active': 2,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-21',
        after: '2023-06-21',
        'branch.computed.cycle_time:avg': 3801,
        'branch.time_to_pr:avg': 3752,
        'branch.time_to_review:avg': 13,
        'branch.review_time:avg': 36,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 114,
        'pr.review_depth': 1,
        'commit.activity.new_work.count': 164,
        'commit.total_changes': 169,
        'commit.activity.refactor.count': 4,
        'commit.activity.rework.count': 1,
        'pr.merged.without.review.count': 1,
        'commit.total.count': 10,
        'pr.new': 3,
        'pr.merged': 2,
        'pr.reviews': 1,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 2,
        'branch.state.active': 3,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-22',
        after: '2023-06-22',
        'branch.computed.cycle_time:avg': 430,
        'branch.time_to_pr:avg': 140,
        'branch.time_to_review:avg': 270,
        'branch.review_time:avg': 20,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': 15,
        'pr.review_depth': 0,
        'commit.activity.new_work.count': 10,
        'commit.total_changes': 11,
        'commit.activity.refactor.count': 1,
        'commit.activity.rework.count': 0,
        'pr.merged.without.review.count': 4,
        'commit.total.count': 6,
        'pr.new': 5,
        'pr.merged': 5,
        'pr.reviews': 1,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 5,
        'branch.state.active': 2,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-23',
        after: '2023-06-23',
        'branch.computed.cycle_time:avg': 455,
        'branch.time_to_pr:avg': null,
        'branch.time_to_review:avg': 455,
        'branch.review_time:avg': null,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': null,
        'pr.review_depth': 0,
        'commit.activity.new_work.count': null,
        'commit.total_changes': null,
        'commit.activity.refactor.count': null,
        'commit.activity.rework.count': null,
        'pr.merged.without.review.count': 0,
        'commit.total.count': 0,
        'pr.new': 0,
        'pr.merged': null,
        'pr.reviews': 1,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 0,
        'branch.state.active': 2,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-24',
        after: '2023-06-24',
        'branch.computed.cycle_time:avg': null,
        'branch.time_to_pr:avg': null,
        'branch.time_to_review:avg': null,
        'branch.review_time:avg': null,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': null,
        'pr.review_depth': null,
        'commit.activity.new_work.count': null,
        'commit.total_changes': null,
        'commit.activity.refactor.count': null,
        'commit.activity.rework.count': null,
        'pr.merged.without.review.count': null,
        'commit.total.count': null,
        'pr.new': null,
        'pr.merged': null,
        'pr.reviews': null,
        'releases.count': null,
        'commit.activity_days': null,
        'branch.state.computed.done': null,
        'branch.state.active': 2,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      },
      {
        before: '2023-06-25',
        after: '2023-06-25',
        'branch.computed.cycle_time:avg': null,
        'branch.time_to_pr:avg': null,
        'branch.time_to_review:avg': null,
        'branch.review_time:avg': null,
        'branch.time_to_prod:avg': null,
        'pr.merged.size:avg': null,
        'pr.review_depth': null,
        'commit.activity.new_work.count': 10,
        'commit.total_changes': 18,
        'commit.activity.refactor.count': 8,
        'commit.activity.rework.count': 0,
        'pr.merged.without.review.count': 0,
        'commit.total.count': 5,
        'pr.new': 0,
        'pr.merged': null,
        'pr.reviews': 0,
        'releases.count': 0,
        'commit.activity_days': 1,
        'branch.state.computed.done': 0,
        'branch.state.active': 3,
        'branch.stage.time_to_qa': null,
        'branch.stage.time_to_stage1': null,
        'branch.stage.time_to_stage2': null
      }
    ]
  }
];

export default {
  groupMetrics: GROUP_METRICS,
  selectedGroup: SELECTED_GROUP,
  groupMetricsTrend: GROUP_METRICS_5_ITERATIONS,
  selectedGroupSynced: SELECTED_GROUP_SYNCED,
  widgetsData: WIDGETS_DATA,
  metricsDataOneDayRollUp: METRICS_DATA_ONE_DAY_ROLL_UP
};
